import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userService } from "../../services/userService";

export const fetchUserInfo = createAsyncThunk(
  "user/fetchInfo",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await userService.getInfoUser(userId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data ? error.response.data : error);
    }
  }
);

export const updateInfoUser = createAsyncThunk(
  "user/updateUser",
  async ({ userId, newInfoUser }, { rejectWithValue }) => {
    try {
      const response = await userService.updateInfoUser(userId, newInfoUser);
      return response.data.dataUser;
    } catch (error) {
      return rejectWithValue(error.response?.data || error);
    }
  }
);

export const changePassword = createAsyncThunk(
  "user/changePassword",
  async ({ userId, changePasswordDTO }, { rejectWithValue }) => {
    try {
      const response = await userService.changePassword(
        userId,
        changePasswordDTO
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    userInfo: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetUser: (state) => {
      state.userInfo = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch Info User
      .addCase(fetchUserInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload;
        state.error = null;
      })
      .addCase(fetchUserInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Info User
      .addCase(updateInfoUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateInfoUser.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload; // Cập nhật thông tin mới
      })
      .addCase(updateInfoUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message || "Cập nhật thất bại";
      })

      // Change Password
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message || "Cập nhật thất bại";
      });
  },
});
export const { resetUser } = userSlice.actions;
export default userSlice.reducer;
